import React from "react";
import { Box, Button, FormControl, Grid, IconButton, Modal, Select, TextField, Typography } from "@mui/material";
import CancelIcon from '@mui/icons-material/Cancel';

import UpdateUser from "../../update-user/UpdateUser";
import * as Yup from "yup";
import styles from './AddDoctorStaffModal.module.css';
import UpdateUserStyles from "../../../pages/update-user/UpdateUser.module.css";
import { useFormik } from "formik";
import MaskedInput from "react-text-mask";
import { LoadingButton } from "@mui/lab";
interface AddDoctorStaffModalProps {
    open?: boolean,
    handleClose?: () => void,
    isUserApproval?: boolean
}

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    padding: "20px 20px 0px 20px",
    maxHeight: "95%",
    borderRadius: 2
};

const handleNavigate = () => {
    
}


const AddDoctorStaffModal = ({ open, handleClose, isUserApproval }: AddDoctorStaffModalProps) => {

    const validationSchema = Yup.object({
        firstName: Yup.string().required("First Name is required"),
        lastName: Yup.string().required("Last Name is required"),
        emailAddress: Yup.string().email("Invalid email address").required("Email is required"),
        roleId: Yup.number().required(),
        phoneNumber: Yup.string()
            .required("Phone number is required")
            .matches(/^\d+$/, "Phone number must be only digits")
            .transform((value, originalValue) => originalValue ? originalValue.replace(/\D/g, '') : originalValue)
            .min(10, "Phone number must be exactly 10 digits")
            .max(10, "Phone number must be exactly 10 digits"),
        // practiceNameId: Yup.array().of(Yup.number()).when('roleId', {
        //     is: (roleId: number) => roleId === USER_ROLES.USER_ADMIN || roleId === DOCTOR_ROLE,
        //     then: schema => schema.required('Practice name is required')
        // }),
    });

    const formik = useFormik({
        // initialValues: userId && userDetails ? updatingValues : addingValues,
        initialValues : {},
        validationSchema: validationSchema,
        enableReinitialize: true,
        onSubmit: async (values) => {
            // await userId ? updateUserDetails(values) : addUserDetails(values);
        },
    });

    return (
        <Modal open={!!open} onClose={handleClose} disableEscapeKeyDown>
            <Box className={styles.modalCont} sx={style}>
                {!isUserApproval && <UpdateUser />}
                {isUserApproval && 
                    <Box className={UpdateUserStyles.container}>
                        <Box className={UpdateUserStyles.search_panal}>
                            <Box className={UpdateUserStyles.panel_container}>
                                <Box className="flexCenterBetween">
                                    <Box className="flexCenterStart pointer" sx={{ width: "200px" }} onClick={handleNavigate}>
                                        <img src="images/back.svg" className={UpdateUserStyles.backImg} alt="back" />
                                        <Typography ml={2} className={UpdateUserStyles.panal_header}>Add New Doctor Staff</Typography>
                                    </Box>
                                </Box>
                            </Box>
                            <form onSubmit={formik.handleSubmit}>
                                <Grid container>
                                    <Grid item lg={4} md={4} sm={6} xs={12} p={3}>
                                        <Typography className={UpdateUserStyles.label}>First Name</Typography>
                                        <TextField
                                            id="firstName"
                                            name="firstName"
                                            variant="standard"
                                            // disabled={isViewPath}
                                            placeholder="Enter a first name"
                                            // value={formik.values.firstName}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            // error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                                            // helperText={formik.touched.firstName && formik.errors.firstName}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item lg={4} md={4} sm={6} xs={12} p={3}>
                                        <Typography className={UpdateUserStyles.label}>Last Name</Typography>
                                        <TextField
                                            id="lastName"
                                            name="lastName"
                                            variant="standard"
                                            // disabled={isViewPath}
                                            placeholder="Enter a last name"
                                            // value={formik.values.lastName}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            // error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                                            // helperText={formik.touched.lastName && formik.errors.lastName}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item lg={4} md={4} sm={6} xs={12} p={3}>
                                        <Typography className={UpdateUserStyles.label}>Email</Typography>
                                        <TextField
                                            id="emailAddress"
                                            name="emailAddress"
                                            variant="standard"
                                            // disabled={isViewPath}
                                            placeholder="Enter an email address"
                                            // value={formik.values.emailAddress}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            // error={formik.touched.emailAddress && Boolean(formik.errors.emailAddress)}
                                            // helperText={formik.touched.emailAddress && formik.errors.emailAddress}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item lg={4} md={4} sm={6} xs={12} p={3}>
                                        <Typography className={UpdateUserStyles.label}>Role</Typography>
                                        <FormControl
                                            variant="standard"
                                            fullWidth
                                            // error={formik.touched.roleId && Boolean(formik.errors.roleId)}
                                        >
                                            <Select
                                                labelId="role-select-label"
                                                id="role-select"
                                                name="roleId"
                                                // disabled={isViewPath || !!showDoctorStaffDialog}
                                                // value={formik.values.roleId!}
                                                // onChange={handleRoleChange}
                                                onBlur={formik.handleBlur}
                                            >
                                                {/* {roleId === USER_ROLES.SUPER_ADMIN ? (
                                                    userRoles.filter(role => role.value !== USER_ROLES.SUPER_ADMIN).map((item) => (
                                                        <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
                                                    ))
                                                ) : roleId === DOCTOR_ROLE ? (
                                                    <MenuItem key={DOCTOR_ROLE} value={DOCTOR_ROLE}>{USER_ROLE_NAMES.DOCTOR}</MenuItem>
                                                ) : roleId === DOCTOR_STAFF_ROLE ? (
                                                    <MenuItem key={DOCTOR_STAFF_ROLE} value={DOCTOR_STAFF_ROLE}>{USER_ROLE_NAMES.DOCTOR_STAFF}</MenuItem>
                                                ) : (
                                                    userRoles
                                                        .filter(role => ![USER_ROLES.SUPER_ADMIN, USER_ROLES.USER_ADMIN].includes(role.value))
                                                        .map((item) => (
                                                            <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
                                                        ))
                                                )} */}
                                                {/* Admin condition for showing admin role during editing */}
                                                {/* {userId && roleId === USER_ROLES.USER_ADMIN && formik.values.roleId === USER_ROLES.USER_ADMIN && (
                                                    <MenuItem key={USER_ROLES.USER_ADMIN} value={USER_ROLES.USER_ADMIN}>
                                                        {USER_ROLE_NAMES.ADMIN}
                                                    </MenuItem>
                                                )} */}
                                            </Select>
                                            {/* {formik.touched.roleId && formik.errors.roleId && (
                                                <FormHelperText>{formik.errors.roleId}</FormHelperText>
                                            )} */}
                                        </FormControl>
                                    </Grid>
                                    <Grid item lg={4} md={4} sm={6} xs={12} p={3}>
                                        <Typography className={UpdateUserStyles.label}>Phone Number</Typography>
                                        <MaskedInput
                                            mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                                            placeholder="Enter a phone number"
                                            guide={false}
                                            id="phoneNumber"
                                            // value={formik.values.phoneNumber!}
                                            onBlur={formik.handleBlur}
                                            // onChange={handlePhoneChange}
                                            render={(ref, props) => (
                                                <TextField
                                                    {...props}
                                                    inputRef={ref}
                                                    variant="standard"
                                                    // disabled={isViewPath}
                                                    // error={formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)}
                                                    // helperText={formik.touched.phoneNumber && formik.errors.phoneNumber}
                                                    fullWidth
                                                />
                                            )}
                                        />
                                    </Grid>

                                </Grid>
                                <Box m={2} sx={{ display: 'flex', alignItems: 'center', justifyContent: { md: 'flex-end', xs: 'center' } }}>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        onClick={handleNavigate}
                                        sx={{
                                            padding: "6px 11px",
                                            minWidth: "120px",
                                            textTransform: "capitalize",
                                            borderRadius: "100px"
                                        }}
                                    >
                                        <Typography sx={{ textTransform: "capitalize", fontWeight: "500" }}>Cancel</Typography>
                                    </Button>
                                    <LoadingButton
                                        variant="contained"
                                        color="primary"
                                        // loading={userAdding}
                                        type="submit"
                                        sx={{
                                            padding: "6px 11px",
                                            minWidth: "120px",
                                            textTransform: "capitalize",
                                            borderRadius: "100px",
                                            marginLeft: "10px"
                                        }}
                                    >
                                        <Typography sx={{ textTransform: "capitalize", fontWeight: "500" }}>Save</Typography>
                                    </LoadingButton>
                                </Box>
                            </form>
                        </Box>
                    </Box>
                    }
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 2,
                        top: 2,
                    }}
                >
                    <CancelIcon color={'primary'} />
                </IconButton>
            </Box>
        </Modal>
    )
}

export default AddDoctorStaffModal;